import { render, staticRenderFns } from "./UsersWidget.vue?vue&type=template&id=6a7405d0&scoped=true"
import script from "./UsersWidget.vue?vue&type=script&lang=js"
export * from "./UsersWidget.vue?vue&type=script&lang=js"
import style0 from "./UsersWidget.vue?vue&type=style&index=0&id=6a7405d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7405d0",
  null
  
)

export default component.exports